import { useEffect,useState } from 'react';
import { getTenantId } from '../api/tenantHeader.ts';
import apiService from '../services/apiService.ts';

export const useTables = (spaceId:string)=>{
  const [resolvedSpaceId, setResolvedSpaceId] = useState('');
  const effectiveSpaceId = spaceId || localStorage.getItem('saSelectedSpace') || resolvedSpaceId;
  const [rows,setRows]=useState<any[]>([]);
  const [loading,setLoading]=useState(false);

  const fetchData=async()=>{
    let nextSpaceId = effectiveSpaceId;
    if (!nextSpaceId) {
      let resolvedLocationId = localStorage.getItem('saSelectedLocation') || '';
      if (!resolvedLocationId) {
        const focusedTenantId = getTenantId();
        if (focusedTenantId) {
          const locations = await apiService.getLocations(String(focusedTenantId));
          if (Array.isArray(locations) && locations[0]?.id) {
            resolvedLocationId = String(locations[0].id);
            localStorage.setItem('saSelectedLocation', resolvedLocationId);
          }
        }
      }

      if (!resolvedLocationId) {
        setRows([]);
        return;
      }

      const spaces = await apiService.getSpaces(resolvedLocationId);
      const firstSpaceId = Array.isArray(spaces) && spaces[0]?.id
        ? String(spaces[0].id)
        : '';
      if (!firstSpaceId) {
        setRows([]);
        return;
      }
      localStorage.setItem('saSelectedSpace', firstSpaceId);
      setResolvedSpaceId(firstSpaceId);
      nextSpaceId = firstSpaceId;
    }
    setLoading(true);
    try{
      const data = await apiService.getTables(nextSpaceId);
      setRows(Array.isArray(data) ? data : []);
    }
    finally{ setLoading(false); }
  };
  useEffect(()=>{
    if (spaceId) {
      localStorage.setItem('saSelectedSpace', spaceId);
    }
    fetchData();
  },[spaceId, effectiveSpaceId]);
  return { rows, loading, refetch: fetchData };
};
